import { render, staticRenderFns } from "./GameConfigSp.vue?vue&type=template&id=54ff8bae&scoped=true&"
import script from "./GameConfigSp.vue?vue&type=script&lang=js&"
export * from "./GameConfigSp.vue?vue&type=script&lang=js&"
import style0 from "./GameConfigSp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GameConfigSp.vue?vue&type=style&index=1&lang=css&"
import style2 from "./GameConfigSp.vue?vue&type=style&index=2&id=54ff8bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ff8bae",
  null
  
)

export default component.exports